<template>
  <div class="transfer-device-dialog">
    <custom-dialog width="90%" :title="model.title" :visible="visible" v-on="$listeners">
      <div class="dialog-body">
        <el-form :model="form" label-position="top" ref="form" :rules="rules">
          <el-row>
            <el-col :span="2" v-if="model.type === 'hq'">
              <el-form-item :label="$t('dms_transfer_device_dialog.mu_biao_zu_zhi')">
                <el-select v-model="targetType" :placeholder="$t('Common.com_please_select')" @change="changeTargetType">
                  <el-option :label="$t('dms_transfer_device_dialog.zi_gong_si')" value="org"></el-option>
                  <el-option :label="$t('dms_transfer_device_dialog.zong_bu')" value="orgHq"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="$t('dms_transfer_device_dialog.mu_biao_zu_zhi')" prop="consigneeOrgId" :class="{ 'label-white': model.type === 'hq' }">
                <custom-select
                  v-if="targetType === 'org'"
                  :filterable="true"
                  :model="form"
                  v-model="form.consigneeOrgId"
                  url="OrganStockTarget"
                  :props="{ label: 'orgName', value: 'orgId', map: { orgType: 'orgType', orgName: 'consigneeOrgName' } }"
                  :params="{ excludeOrgId: model.row.orgId }"
                  @change="onChangeTarget"
                  width="90%"
                ></custom-select>
                <custom-select
                  v-if="targetType === 'orgHq'"
                  :filterable="true"
                  :model="form"
                  v-model="form.consigneeOrgId"
                  url="OrganHqList"
                  :props="{ label: 'orgName', value: 'orgId', map: { orgType: 'orgType', orgName: 'consigneeOrgName' } }"
                  :params="{ isExcludeSelf: true }"
                  @change="onChangeTarget"
                  width="90%"
                ></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item :label="$t('dms_transfer_device_dialog.fa_huo_dan_hao')" prop="shipmentNum">
                <el-input maxlength="30" v-model="form.shipmentNum" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('dms_transfer_device_dialog.ye_wu_lei_xing')" prop="bizType">
                <el-radio-group v-model="form.bizType">
                  <el-radio :label="90" :disabled="form.orgType == 'CS'">{{ $t('dms_transfer_device_dialog.ku_cun') }}</el-radio>
                  <el-radio :label="10" :disabled="form.orgType == 'HQ' || form.orgType == 'JV' || form.orgType == 'SC' || form.orgType == 'JV_SC'">{{ $t('dms_transfer_device_dialog.shi_yong') }}</el-radio>
                  <el-radio :label="20" :disabled="form.orgType == 'HQ' || form.orgType == 'JV' || form.orgType == 'SC' || form.orgType == 'JV_SC'">{{ $t('dms_transfer_device_dialog.zu_lin') }}</el-radio>
                  <el-radio :label="40" :disabled="form.orgType == 'HQ' || form.orgType == 'SC'">{{ $t('dms_transfer_device_dialog.xiao_shou') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="4" v-if="targetType === 'org'">
              <el-form-item :label="$t('dms_transfer_device_dialog.sfzdsh')">
                <el-select v-model="isAutoReceive" :placeholder="$t('Common.com_please_select')" style="width: 96%">
                  <el-option :label="$t('Common.com_yes')" :value="1"></el-option>
                  <el-option :label="$t('Common.com_no')" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="table-bd">
          <custom-table
            tableCode="stockTransfer1"
            :data="tableList"
            :filterArr="tableColumnFilter"
            :slots="['deviceBizType', 'orderCharged', 'shipmentTime', 'rentalSaleTime', 'rentalStartTime', 'rentalEndTime', 'locationSiteName']"
          >
            <template v-slot:deviceBizType="scope">
              <custom-select :clearable="false" v-model="scope.row.deviceBizType" code="dms_device_biz_type" :props="{ label: 'name', value: 'value' }" width="100%"></custom-select>
            </template>
            <template v-slot:orderCharged="scope">
              <custom-select :clearable="false" v-model="scope.row.orderCharged" code="isynergy_cloud_bool" width="100%"></custom-select>
            </template>
            <template v-slot:shipmentTime="scope">
              <custom-date-picker
                style="width: 100%"
                v-model="scope.row.shipmentTime"
                type="date"
                :placeholder="scope.$index === 0 ? '' : $t('dms_transfer_device_dialog.mo_ren_tong_shang')"
                value-format="YYYY-MM-DD HH:mm:ss"
                @change="changeSaleTime($event, scope.row)"
              ></custom-date-picker>
            </template>
            <template v-slot:rentalSaleTime="scope">
              <custom-date-picker
                style="width: 100%"
                v-model="scope.row.rentalSaleTime"
                type="date"
                :placeholder="scope.$index === 0 ? '' : $t('dms_transfer_device_dialog.mo_ren_tong_shang')"
                value-format="YYYY-MM-DD HH:mm:ss"
                @change="changeSaleTime($event, scope.row)"
              ></custom-date-picker>
            </template>
            <template v-slot:rentalStartTime="scope">
              <custom-date-picker
                style="width: 100%"
                v-model="scope.row.rentalStartTime"
                type="date"
                :placeholder="scope.$index === 0 ? '' : $t('dms_transfer_device_dialog.mo_ren_tong_shang')"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="{
                  disabledDate(time) {
                    return scope.row.rentalEndTime ? $moment(time).isAfter(new Date(`${scope.row.rentalEndTime}Z`).getTime(), 'day') : undefined;
                  },
                }"
              ></custom-date-picker>
            </template>
            <template v-slot:rentalEndTime="scope">
              <custom-date-picker
                style="width: 100%"
                v-model="scope.row.rentalEndTime"
                type="date"
                :placeholder="scope.$index === 0 ? '' : $t('dms_transfer_device_dialog.mo_ren_tong_shang')"
                value-format="YYYY-MM-DD HH:mm:ss"
                :picker-options="{
                  disabledDate(time) {
                    return scope.row.rentalStartTime
                      ? $moment(time).isBefore(new Date(`${scope.row.rentalStartTime}Z`).getTime(), 'day') || $moment(time).isBefore(new Date().getTime(), 'day')
                      : $moment(time).isBefore(new Date().getTime(), 'day');
                  },
                }"
              ></custom-date-picker>
            </template>
            <template v-slot:locationSiteName="scope">
              <el-input size="small" v-model="scope.row.locationSiteName" :placeholder="scope.$index === 0 ? '' : $t('dms_transfer_device_dialog.mo_ren_tong_shang')" style="width: 140px; vertical-align: middle" :disabled="true"></el-input>
              <el-button size="small" :disabled="!form.consigneeOrgId" style="margin-left: 8px; float: none; vertical-align: middle" type="text" @click="onSelectDialog(scope.row, scope.$index)">
                {{ $t('dms_transfer_device_dialog.xuan_ze') }}
              </el-button>
            </template>
          </custom-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="confirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
    <location-site-select-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onConfirmLocation"></location-site-select-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import locationSiteSelectDialog from '@/pages/dms/components/location_site_select_dialog.vue';

export default {
  mixins: [dialogMixins],
  components: { locationSiteSelectDialog },
  data() {
    return {
      targetType: 'org',
      tableList: [],
      isAutoReceive: 1,
      totalRows: null,
      formSearch: {
        pageNum: 1,
        pageSize: 50,
      },
      form: {
        bizType: '',
        shipmentNum: '',
        consigneeOrgId: '',
        consigneeOrgName: '',
      },
      dialogModel: {},
      dialogVisible: false,
      rowIndex: 0,
    };
  },
  computed: {
    rules() {
      return {
        bizType: [
          {
            required: true,
            message: this.$t('dms_transfer_device_dialog.qxzywlx'),
          },
        ],
        consigneeOrgId: [
          {
            required: true,
            message: this.$t('dms_transfer_device_dialog.qxzmbzz'),
          },
        ],
      };
    },
    // 日期显示格式化
    tableColumnFilter: (vm) => {
      if (`${vm.form.bizType}` === '90') {
        return ['orderCharged', 'rentalSaleTime', 'rentalStartTime', 'rentalEndTime'];
      } else if (`${vm.form.bizType}` === '10' || `${vm.form.bizType}` === '20') {
        return ['shipmentTime', 'rentalSaleTime'];
      } else if (`${vm.form.bizType}` === '40') {
        return ['shipmentTime', 'rentalStartTime', 'rentalEndTime'];
      }
      return ['orderCharged', 'shipmentTime', 'rentalSaleTime', 'rentalStartTime', 'rentalEndTime'];
    },
  },
  mounted() {
    this.tableList = [
      {
        ...this.model.row,
        deviceBizType: this.model.row.nextDeviceBizType,
        orderCharged: '1',
        rentalStartTime: '',
        rentalEndTime: '',
        locationId: '',
        locationName: '',
        siteId: '',
        siteName: '',
        locationSiteName: '',
      },
    ];
  },
  methods: {
    changeSaleTime: function (value, row) {
      row.rentalStartTime = value;
    },
    // 选择项目区域
    onSelectDialog: function (row, index) {
      this.rowIndex = index;
      this.dialogModel.title = this.$t('dms_transfer_device_dialog.xuan_ze_xiang_muo', [this.form.consigneeOrgName]);
      this.dialogModel.row = {
        ...row,
        orgId: this.form.consigneeOrgId,
        orgName: this.form.consigneeOrgName,
      };
      this.dialogVisible = true;
    },
    // 确认选择
    onConfirmLocation: function (form) {
      const idx = this.rowIndex;
      this.tableList[idx]['locationId'] = form.locationId;
      this.tableList[idx]['locationName'] = form.locationName;
      this.tableList[idx]['siteId'] = form.siteId || '';
      this.tableList[idx]['siteName'] = form.siteName || '';
      this.tableList[idx]['locationSiteName'] = form.siteName ? `${form.locationName}/${form.siteName}` : form.locationName;
      const data = this.tableList;
      this.tableList = [];
      this.$nextTick(() => {
        this.tableList = data;
      });
    },
    // 更改组织类型
    changeTargetType() {
      this.form.consigneeOrgId = '';
      this.form.consigneeOrgName = '';
    },
    // 变更目标组织
    onChangeTarget: function () {
      this.form.bizType = '';
      this.tableList[0]['locationId'] = '';
      this.tableList[0]['locationName'] = '';
      this.tableList[0]['siteId'] = '';
      this.tableList[0]['siteName'] = '';
      this.tableList[0]['locationSiteName'] = '';
    },
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(this.targetType === 'orgHq' ? apis.stockTransferHq : apis.stockTransfer, {
          deviceList: this.tableList,
          consigneeOrgId: this.form.consigneeOrgId,
          deviceBizClass: this.form.bizType,
          shipmentNum: this.form.shipmentNum,
          isAutoReceive: !!(this.targetType === 'orgHq' ? 0 : this.isAutoReceive),
        }).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.visible = false;
          this.clearKeepAlive('stockRecord');
          this.$emit('success');
        });
      });
    },
  },
};
</script>

<style lang="scss">
.transfer-device-dialog .label-white .el-form-item__label {
  opacity: 0;
}
</style>
